<template>
<el-dialog :close-on-click-modal="false" width="80%" v-bind="$attrs" v-on="$listeners" custom-class="body_dilog" append-to-body>
    <div class="n-hu xuanzewuliao">
        <div class="h-pieceTitle2">
            <h1>新增虚拟物料</h1>
        </div>
        <div class="h-row h-mrt0">
            <div class="h-rowIn">
                <div class="h-rowCon">
                    <div class="h-pieceIn2">
                        <div class="h-pieceCon2">
                            <div class="h-formLine clclass">
                                <el-form :model="zy" label-position="right" ref="zy" :rules="rules"
                                         :inline="true" class="demo-ruleForm h-formbLine h-formbLine1">
                                    <el-form-item label="业务类型" prop="ywlx" :rules="[
                              { required: true, message: '请选择', trigger: 'blur'},
                            ]" class="h-elformWrap-2">
                                        <brselect category="IN_TYPE" :v="zy.ywlx"
                                                  v-model="zy.ywlx"></brselect>
                                    </el-form-item>

                                    <el-form-item label="物料型号" class="h-elformWrap-2" prop="wlxh">
                                        <el-input placeholder="请输入"  v-model="zy.wlxh"></el-input>
                                    </el-form-item>

                                    <el-form-item label="基本单位" prop="jbdw" :rules="[
                              { required: true, message: '请选择', trigger: 'blur'},
                            ]" class="h-elformWrap-2">
                                        <brselect category="YLUnit" :v="zy.jbdw"
                                                  v-model="zy.jbdw"></brselect>
                                    </el-form-item>

                                    <el-form-item label="物料组" prop="wlz" :rules="[
                              { required: true, message: '请选择', trigger: 'blur'},
                            ]" class="h-elformWrap-2">
                                        <template>
                                            <brselectlazy category="YLMaterialGroup" :v="zy.wlz"
                                                          v-model="zy.wlz"></brselectlazy>
                                        </template>
                                    </el-form-item>
                                    <el-form-item label="旧物料号" class="h-elformWrap-2" prop="jwlh">
                                        <el-input placeholder="请输入" v-model="zy.jwlh"></el-input>
                                    </el-form-item>

                                    <el-form-item label="产品组" prop="cpz" :rules="[
                              { required: false, message: '请选择', trigger: 'blur'},
                            ]" class="h-elformWrap-2">
                                        <brselect category="YLProductGroup" :v="zy.cpz"
                                                  v-model="zy.cpz"></brselect>
                                    </el-form-item>
                                    <el-form-item label="实验室" prop="sys" :rules="[
                              { required: false, message: '请选择', trigger: 'blur'},
                            ]" class="h-elformWrap-2">
                                        <brselect category="Laboratory" :v="zy.sys"
                                                  v-model="zy.sys"></brselect>
                                    </el-form-item>


                                    <el-form-item label="外部物料组" class="h-elformWrap-2">
                                        <el-input placeholder="请输入" v-model="zy.wbwlz"></el-input>
                                    </el-form-item>
                                    <el-form-item label="税分类" prop="sfl" :rules="[
                              { required: true, message: '请选择', trigger: 'blur'},
                            ]" class="h-elformWrap-2">
                                        <brselect category="YLMtlTaxType" :v="zy.sfl"
                                                  v-model="zy.sfl"></brselect>
                                    </el-form-item>

                                    <el-form-item label="产品注册号" class="h-elformWrap-2">
                                        <el-input placeholder="请输入" v-model="zy.cpzch"></el-input>
                                    </el-form-item>
                                    <el-form-item label="储运条件" class="h-elformWrap-2">
                                        <el-input placeholder="请输入" v-model="zy.cytj"></el-input>
                                    </el-form-item>
                                    <el-form-item label="产地" class="h-elformWrap-2">
                                        <el-input placeholder="请输入" v-model="zy.cd"></el-input>
                                    </el-form-item>

                                    <el-form-item label="产品层次" prop="cpcc" :rules="[
                              { required: true, message: '请选择', trigger: 'blur'},]" class="h-elformWrap-2">
                                        <template>
                                            <brselectlazy category="YLProdHierarchy" :v="zy.cpcc"
                                                          v-model="zy.cpcc"></brselectlazy>
                                        </template>

                                    </el-form-item>

                                    <el-form-item label="生产商" class="h-elformWrap-2">
                                        <el-input placeholder="请输入" v-model="zy.scs"></el-input>
                                    </el-form-item>


                                    <el-form-item label="小微编码" prop="xwbm" :rules="[
                              { required: false, message: '请选择', trigger: 'blur'},
                            ]" class="h-elformWrap-2">
                                        <brselect category="YLXW" :v="zy.xwbm"
                                                  v-model="zy.xwbm"></brselect>
                                    </el-form-item>

                                    <el-form-item label="生态硬件属性" prop="styjsx" :rules="[
                              { required: false, message: '请选择', trigger: 'blur'},
                            ]" class="h-elformWrap-2">
                                        <brselect category="YLEcology" :v="zy.styjsx"
                                                  v-model="zy.styjsx"></brselect>
                                    </el-form-item>

                                    <el-form-item label="生态收入" prop="stsr" :rules="[
                              { required: false, message: '请选择', trigger: 'blur'},
                            ]" class="h-elformWrap-2">
                                        <brselect category="YLEcologyIn" :v="zy.stsr"
                                                  v-model="zy.stsr"></brselect>
                                    </el-form-item>

                                    <el-form-item label="产品有效期" prop="youxiaoqi" :rules="[
                              {required: true, message: '请输入四位整数年份-只能填写正整数', trigger: 'change'},
                            ]" class="h-elformWrap-2">

                                        <el-input v-model.number="zy.youxiaoqi" placeholder="请输入四位整数年份"
                                                  oninput="value=value.replace(/[^\d]/g, '')"
                                                  maxlength="4">
                                        </el-input>

                                    </el-form-item>
                                    <el-form-item label="行业标准描述" class="h-elformWrap-2">
                                        <el-input placeholder="请输入" v-model="zy.hybzms"></el-input>
                                    </el-form-item>
                                    <el-form-item label="上传凭证" class="h-elformWrap-1" prop="upload">
                                        <brupload
                                                :refid="mdmchanpinid"
                                                reftype="shangchuanpingzheng"
                                                uploadflag
                                                delflag>
                                        </brupload>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="h-txtCenter h-mrt60">
            <el-button class="h-btn h-bBtn h-bgblue2" @click="tijiaozhimdm"  >
                提交至MDM
            </el-button>
        </div>
    </div>
</el-dialog>
</template>

<script>
    import ss from '../../api/SystemService'
    export default {
        data(){
          return {
              zy: {
                  id: null,
                  ywlx: null,
                  wlxh: null,
                  wlms: null,
                  jbdw: null,
                  wlz: null,
                  jwlh: null,
                  cpz: null,
                  sys: null,
                  wbwlz: null,
                  sfl: null,
                  cpzch: null,
                  cytj: null,
                  cd: null,
                  cpcc: null,
                  scs: null,
                  xwbm: null,
                  styjsx: null,
                  stsr: null,
                  youxiaoqi: null,
                  pingzheng: null,
                  hybzms: null,
                  cjrzh: null,
                  shenpiyijian: null,
              },
              rules: {
                  ywlx: [
                      {required: true, message: '请选择业务类型', trigger: 'blur'}
                  ],
                  wlxh: [
                      {required: true, message: '请选择物料型号', trigger: 'blur'}
                  ],
                  wlms: [
                      {required: true, message: '请输入物料描述', trigger: 'blur'}
                  ],
                  jbdw: [
                      {required: true, message: '请选择基本单位', trigger: 'blur'}
                  ],
                  wlz: [
                      {required: true, message: '请选择物料组', trigger: 'blur'}
                  ],
                  jwlh: [
                      {required: true, message: '请输入旧物料号', trigger: 'blur'}
                  ],
                  sfl: [
                      {required: true, message: '请选择税分类', trigger: 'blur'}
                  ],
                  cpcc: [
                      {required: true, message: '请选择产品层次', trigger: 'blur'}
                  ]
              },
          }
        },
        created(){

        },
        computed:{
            mdmchanpinid: function () {
                return this.chanpid;
            },
            mdmxinghao:function(){
                return this.xinghao;
            },
        },
        mounted(){
            this.zy.wlxh=this.mdmxinghao
        },
        methods: {
            tijiaozhimdm(){
                var params = this.getMdmParams();
                ss.chanpin.addMdmtijiao(params).then(rd => {
                    console.log(rd)
                    var params2 = {
                        id:this.mdmchanpinid,
                        productId:rd.truematerial.materialCode,
                        xuniFlag:0,
                    };
                    ss.Product.updateXuniTozhanshi(params2).then(rd=>{
                        this.$msg.msgs("转换真实物料成功！");
                        this.$emit('callback');
                    });
                })
            },
            getMdmParams(){
                return {
                    id: this.mdmchanpinid,//虚拟物料id
                    materialCode: this.mdmchanpinid,// 真实物料id里先也存一个虚拟物料id
                    oemType: this.zy.ywlx,
                    materialDescrition: this.zy.wlxh,
                    primaryUom: this.zy.jbdw,
                    materialGroupCode: this.zy.wlz,
                    oldMaterialNumber: this.zy.jwlh,
                    Department: this.zy.cpz,
                    labStudio: this.zy.sys,
                    extMtlGroup: this.zy.wbwlz,
                    Tax: this.zy.sfl,
                    productRegNum: this.zy.cpzch,
                    shipCondition: this.zy.cytj,
                    placeOrigin: this.zy.cd,
                    productHierarchy: this.zy.cpcc,
                    manufacturer: this.zy.scs,
                    zattr5u: this.zy.xwbm,
                    ecology: this.zy.styjsx,
                    ecologyIn: this.zy.stsr,
                    zcpyxq: parseInt(this.zy.youxiaoqi),
                    industryStdDesc: this.zy.hybzms,
                    cucode: this.zy.cjrzh,
                }
            }
        },
        props: {
            xinghao: {
                type: String,
            },
            chanpid: {
                type: String,
            },
        }
    }
</script>

<style>
    .xuanzewuliao .el-dialog__header{
        padding-top: 20px;
        padding-left: 20px;
    }
    .xuanzewuliao .el-dialog__body{
        padding: 20px;
    }
    .xuanzewuliao .el-table tbody td .cell {
        padding: 0.1rem 0.1rem !important;
    }
    .xuanzewuliao .h-formbLine .el-form-item__label{
        width: 30%;
    }
    .xuanzewuliao  .h-formbLine .el-form-item__content{
        width: 70%;
    }
    .xuanzewuliao .yxline .h-formbLine .el-form-item__content{
        width: 70%;
    }
    .xuanzewuliao .yxline{
        padding-top: 0;
    }
    .xuanzewuliao .h-pagination{
        padding-top: 0rem;
        padding-bottom: 0rem;
    }
    .xuanzewuliao .h-rowCon{
        padding-bottom: 0rem;
    }
</style>
